import React, { PureComponent, PropTypes } from 'react';
import classNames from 'classnames';


export default class Button extends PureComponent {
  static propTypes = {
    active: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    hasValue: PropTypes.bool.isRequired,
  };

  render() {
    const { active, onClick, label, hasValue } = this.props;
    return (
      <button
        type="button"
        className={classNames("btn col btn-secondary", { active, hasValue })}
        onClick={onClick}
      >
        {label} <i className="fa fa-calendar-o"></i>
      </button>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/PeriodPicker/Button.js